import React from "react";
import loaderGIF from "../assets/images/Reports/loaderGIF.gif";
import "@frameworks/web/stylesheets/components/Reports/HoldingReports/SmcasePopupLoader.scss";
var LoadingPopup = function (props) {
    return (React.createElement("div", { className: "modalBackground" },
        React.createElement("div", { className: "modalContainer" },
            React.createElement("div", { className: "smallcase-popup-loader" },
                React.createElement("div", { className: "modal-header bg_aqua_white" }, props.Title),
                React.createElement("div", { className: "smallcase-popup-loader-body" },
                    React.createElement("img", { className: "loader", src: loaderGIF, alt: "loaderGIF" }),
                    React.createElement("label", { className: "update-message DMSans_16_500 txt_primaryGrey" }, props.message
                        ? props.message
                        : "Your request is being processed"))))));
};
export default LoadingPopup;
